import { useLocation } from "react-router-dom";
const queryString = require("query-string");

const useQueryString = () => {
  const location = useLocation();
  return queryString.parse(location?.search) || {};
};

export default useQueryString;
